


import { mapState } from 'vuex'
export default {
data () {
return {
}
},
props: {
},
components: {
},
computed: {
...mapState({
deviceInfo: state => state.user.deviceInfo,
}),
},
beforeCreate () {

},
mounted () {

},
beforeDestroy () {

},
methods: {

}
}



// WEBPACK FOOTER //
// ./src/common/components/page/PageContainer.vue